import { ProfileTypes } from "@services/data-types/user"

export const authTokenInitial = {
    token: "",
    token_type: "bearer",
    expires_in: 60,
    refresh_token: ""
}

export const profileInitial: ProfileTypes = {
    id: "",
    student_id: "",
    fullname: "",
    img_profile: "",
    email: "",
    phone_number: "",
    allow_notification: 0,
    role: "",
    groups: [],
    faculty: "",
    tnc_url: "",
    privacy_policy_url: "",
    company_profile: "",
    company_profile_url: "",
    status_notification: 0,
    permissions: []
}